export const formatCurrency = (value: number | bigint): string => {
  if (!value) {
    return '';
  }

  const formatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(value);
};
